const isElementWithChildren = el =>
  Object.prototype.hasOwnProperty.call(el, 'props') && Object.prototype.hasOwnProperty.call(el.props, 'children');

// eslint-disable-next-line no-use-before-define
const reduceJsxToString = (curr, next) => curr + innerText(next);

export const innerText = el => {
  if (_.isNull(el)) {
    return '';
  }

  switch (typeof el) {
    case 'undefined':
      return '';
    case 'boolean':
      return '';
    case 'number':
      return el.toString();
    case 'string':
      return el;
    default:
      break;
  }

  if (Array.isArray(el)) {
    return el.reduce(reduceJsxToString, '');
  }

  if (isElementWithChildren(el)) {
    return innerText(el.props.children);
  }

  return '';
};
